import { createReducer, on, Action } from '@ngrx/store';
import * as UserProfileActions from './userProfile.actions';

export interface UserProfileState {
  loading: boolean;
  error: any;
  data: any;
  profile: any;
  message: string;
}

export const initialState: UserProfileState = {
  loading: false,
  error: null,
  data: null,
  profile: null,
  message: ''
};

export const userProfileReducer = createReducer(
  initialState,
  on(UserProfileActions.submitUserProfile, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserProfileActions.submitUserProfileSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    data: response, // Make sure this correctly refers to the actual data structure you expect
    error: null
  })),
  on(UserProfileActions.submitUserProfileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error
  })),
  on(UserProfileActions.fetchUserProfile, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserProfileActions.fetchUserProfileSuccess, (state, { data }) => ({
    ...state,
    loading: false,
    data,
    error: null
  })),
  on(UserProfileActions.fetchUserProfileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(UserProfileActions.updateUserProfile, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(UserProfileActions.updateUserProfileSuccess, (state, { profile }) => ({
    ...state,
    profile,
    loading: false
  })),
  on(UserProfileActions.updateUserProfileFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(UserProfileActions.skipSetup, state => ({
    ...state,
    loading: true,
    error: null,
    message: ''
  })),
  on(UserProfileActions.skipSetupSuccess, (state, { message }) => ({
    ...state,
    loading: false,
    message: message,
    error: null
  })),
  on(UserProfileActions.skipSetupFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error,
    message: ''
  }))
);
